<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wineTemplate.list")}}</span>
    <div class="searchable-list-container">
      <AveineWineTemplateList :APIbaseURL="APIbaseURL" :adminMode="true"/>
    </div>
  </div>
</template>

<script>
import { AveineWineTemplateList } from 'aveine-wine';
export default {
  name: 'Index',
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineWineTemplateList
  }
}
</script>
